/* Adds named events to the existing Clarity integration; never installs a second tracker. */
(() => {
  const config = document.currentScript;
  const pageType = config?.dataset.pageType || 'unknown';
  const articleHandle = config?.dataset.articleHandle || '';
  const permitted = () => typeof window.clarity === 'function' &&
    window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function event(name) {
    if (!permitted()) return;
    window.clarity('set', 'page_type', pageType);
    if (articleHandle) window.clarity('set', 'article_handle', articleHandle);
    window.clarity('event', name);
  }
  document.addEventListener('click', (e) => {
    const link = e.target.closest?.('a[href]');
    if (link) {
      const href = link.getAttribute('href') || '';
      if (/^tel:/i.test(href)) event('contact_phone_click');
      else if (/^mailto:/i.test(href)) event('contact_email_click');
      else if (/^https?:\/\/(wa\.me|api\.whatsapp\.com)\//i.test(href)) event('contact_whatsapp_click');
      if (pageType === 'article') {
        const url = new URL(href, location.origin);
        if (url.origin === location.origin && /^\/products\//.test(url.pathname)) event('article_product_click');
        else if (url.origin === location.origin && /^\/blogs\//.test(url.pathname)) event('article_related_click');
      }
    }
    if (e.target.closest?.('button[name="checkout"],a[href="/checkout"]')) event('checkout_click');
  }, { capture: true });
  const article = document.querySelector('.pu-buying-guide__body, .app-oxy-blog-item-main-content');
  if (pageType !== 'article' || !article) return;
  const seen = new Set();
  let queued = false;
  function progress() {
    queued = false;
    if (!permitted()) return;
    const rect = article.getBoundingClientRect();
    if (!rect.height) return;
    const percent = Math.max(0, Math.min(100, (innerHeight - rect.top) / rect.height * 100));
    [25, 50, 75, 100].forEach((threshold) => {
      if (percent >= threshold && !seen.has(threshold)) {
        seen.add(threshold);
        event('article_scroll_' + threshold);
      }
    });
  }
  window.addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(progress); }
  }, { passive: true });
  document.addEventListener('visitorConsentCollected', progress);
  window.addEventListener('load', progress, { once: true });
})();
